// Interface ====
export class Entry {
    title: string;
    photo: string;
    description: string;
    comments: any[]
  }


// WEBPACK FOOTER //
// C:/Users/Aimee/Desktop/git/Angular/aimees-photo-blog/src/app/entry.model.ts